import request from '@/utils/request'

/**
 * 根据租户分组，查询功能模块管理分页
 * @returns
 */
export const findModuleTenantGroupPage = (data) => {
  return request({
    url: '/sys/v1/appTenant/findModuleTenantGroupPage',
    params: data
  })
}

/**
 * 批量保存功能菜单模块
 * @param {*} data
 * @returns
 */
export const saveBatchModule = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/appTenant/saveBatch',
    data
  })
}

/**
 * 根据租户id查询所有功能模块菜单 【父子级】
 * @returns
 */
export const findAllModuleMenuByTenantId = (data) => {
  return request({
    url: '/sys/v1/appTenant/findAllMoudleMenuByTenantId',
    params: data
  })
}

/**
 * 根据租户id查询所有功能模块菜单【用于角色处查询所有功能并去重】
 * @returns
 */
export const findAllMenuByTenantId = (data) => {
  return request({
    url: '/sys/v1/appTenant/findAllMenuByTenantId',
    params: data
  })
}

/**
 * 根据租户id删除当前租户下功能模块
 * @param {*} tenantId
 * @returns
 */
export const deleteModuleByTenantId = (tenantId) => {
  return request({
    method: 'DELETE',
    url: `/sys/v1/appTenant/deleteModuleByTenantId/${tenantId}`
  })
}

/**
 * 批量修改功能菜单模块
 * @param {*} data
 * @returns
 */
// export const updateModule = (data) => {
//   return request({
//     method: 'POST',
//     url: '/sys/v1/appTenant/updateModuleById',
//     data
//   })
// }

/**
 * 查询所有应用配置分页
 * @param {*}
 * @returns
 */
export const getModuleConfig = (params) => {
  const formData = new FormData()
  for (const key in params) {
    formData.append(key, params[key])
  }

  params = new URLSearchParams(formData)

  return request({
    url: '/sys/v1/app/page-plus',
    params
  })
}

/**
 * 新增授权功能模块配置
 * @param {*} data
 * @returns
 */
export const saveModuleConfig = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/app/insertDongleApp',
    data
  })
}

/**
 * 新增授权功能模块配置
 * @param {*} data
 * @returns
 */
export const saveConfig = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/app/insert',
    data
  })
}

/**
 * 根据id获取授权功能模块
 * @param {*} id
 * @returns
 */
export const getModuleConfigById = (id) => {
  return request({
    url: `/sys/v1/app/${id}`
  })
}

/**
 * 修改授权功能模块配置
 * @param {*} data
 * @returns
 */
export const updateModuleConfig = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/app/update',
    data
  })
}

/**
 * 根据应用配置id查询应用下配置的功能菜单
 * @returns
 */
export const findAllModuleMenuByConfigId = (params) => {
  return request({
    url: '/sys/v1/app/findAppMenuById',
    params
  })
}
/**
 * 根据应用配置id查询应用下配置的功能菜单
 * @returns
 */
export const findAllModuleConfigMenu = (params) => {
  return request({
    url: '/sys/v1/app/findAppMenuById',
    params
  })
}

/**
 * 根据应用id删除应用配置
 * @returns
 */
export const delModuleMenuByConfigId = (id) => {
  return request({
    method: 'DELETE',
    url: `/sys/v1/app/${id}`
  })
}

/**
 * 新增某个应用，以及应用下的功能
 * @param {*} data
 * @returns
 */
export const saveModule = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/appTenant/addAppTenant',
    data
  })
}

/**
 * 修改某个应用，以及应用下的功能
 * @param {*} data
 * @returns
 */
export const updateModule = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/appTenant/updateAppTenant',
    data
  })
}

/**
 * 新增某个应用，以及应用下的功能
 * @param {*} data
 * @returns
 */
export const findApplyByTenant = (params) => {
  return request({
    url: '/sys/v1/appTenant/findApplyByTenant',
    params
  })
}

/**
 * 根据应用id查询应用下的所有功能模块菜单
 * @param {*} data
 * @returns
 */
export const findAllMoudleMenuByAppId = (params) => {
  return request({
    url: '/sys/v1/appTenant/findAllMoudleMenuByAppId',
    params
  })
}

/**
 * 根据id删除某个应用，以及应用下的功能
 * @param {*} id
 * @returns
 */
export const delMoudle = (id) => {
  return request({
    method: 'DELETE',
    url: `/sys/v1/appTenant/deleteApply/${id}`
  })
}
